export interface IAppState {
  isMobile?: boolean
  isTablet?: boolean
}

export const initialState: IAppState = {
  isMobile: false,
  isTablet: false,
}
